import { Text } from '@factorialco/deprecated-design-system'

import { dateBackendDateTimeToUI } from 'modules/core/lib/dates'

export const DateLabel = ({ date }: { date: string | undefined }) => {
  return <Text.Normal size="200">{date ? dateBackendDateTimeToUI(date) : '-'}</Text.Normal>
}
